import * as actionTypes from "../actionTypes";
import createReducer from "../lib/createReducer";

const defaultState = {
	activeReportSearchId: null,
	activeSearchId: null,
	binderId: null,
	binderTabDrawerOpen: false,
	binderTabDrawerType: null,
	binderTabId: null,
	changeWarningOpen: false,
	printPreview: false,
	printPreviewDetails: false,
};

function SEARCH_DELETE(state, action) {
	const { searchId } = action;
	if (state.activeSearchId && state.activeSearchId === searchId) {
		return {
			...state,
			activeSearchId: null,
		};
	}

	return state;
}

function REPORT_SEARCH_DELETE(state, action) {
	const { reportSearchId } = action;
	if (state.activeReportSearchId && state.activeReportSearchId === reportSearchId) {
		return {
			...state,
			activeReportSearchId: null,
		};
	}

	return state;
}

function UI_SET_ACTIVE_SEARCH_ID(state, action) {
	const { searchId } = action;
	return {
		...state,
		activeSearchId: searchId,
		activeReportSearchId: null,
	};
}

function UI_SET_ACTIVE_REPORT_SEARCH_ID(state, action) {
	const { reportSearchId } = action;
	return {
		...state,
		activeSearchId: null,
		activeReportSearchId: reportSearchId,
	};
}

function UI_SET_CURRENT_BINDER(state, action) {
	const { binderId, binderTabId } = action;
	return {
		...state,
		activeSearchId: binderId === null ? null : state.activeSearchId,
		activeReportSearchId: binderId === null ? null : state.activeReportSearchId,
		binderId,
		binderTabId,
	};
}

function UI_SET_CHANGE_WARNING_OPEN(state, action) {
	const { open } = action;
	return {
		...state,
		changeWarningOpen: open,
	};
}

function UI_SET_BINDER_TAB_DRAWER_OPEN(state, action) {
	const { open } = action;
	return {
		...state,
		binderTabDrawerOpen: open,
	};
}

function UI_SET_BINDER_TAB_TYPE(state, action) {
	const { open, drawerType } = action;
	return {
		...state,
		binderTabDrawerOpen: open,
		binderTabDrawerType: drawerType,
	};
}
function UI_SET_PRINT_PREVIEW(state, action) {
	const { printPreview } = action;
	return {
		...state,
		printPreview,
	};
}

function UI_SET_PRINT_PREVIEW_DETAILS(state, action) {
	const { printPreviewDetails } = action;
	return {
		...state,
		printPreviewDetails,
	};
}

const handlers = {};
handlers[actionTypes.SEARCH_DELETE] = SEARCH_DELETE;
handlers[actionTypes.REPORT_SEARCH_DELETE] = REPORT_SEARCH_DELETE;
handlers[actionTypes.UI_SET_ACTIVE_SEARCH_ID] = UI_SET_ACTIVE_SEARCH_ID;
handlers[actionTypes.UI_SET_ACTIVE_REPORT_SEARCH_ID] = UI_SET_ACTIVE_REPORT_SEARCH_ID;
handlers[actionTypes.UI_SET_CURRENT_BINDER] = UI_SET_CURRENT_BINDER;
handlers[actionTypes.UI_SET_CHANGE_WARNING_OPEN] = UI_SET_CHANGE_WARNING_OPEN;
handlers[actionTypes.UI_SET_BINDER_TAB_DRAWER_OPEN] = UI_SET_BINDER_TAB_DRAWER_OPEN;
handlers[actionTypes.UI_SET_BINDER_TAB_TYPE] = UI_SET_BINDER_TAB_TYPE;
handlers[actionTypes.UI_SET_PRINT_PREVIEW] = UI_SET_PRINT_PREVIEW;
handlers[actionTypes.UI_SET_PRINT_PREVIEW_DETAILS] = UI_SET_PRINT_PREVIEW_DETAILS;
export default createReducer(defaultState, handlers);
